// @flow strict
import * as React from 'react'
import styles from './SocialWidget.module.scss'
import {
  FacebookIcon,
  LinkedInIcon,
  MailIcon,
  TwitterIcon,
  AccessibilityText,
} from '@mondough/public-web-components'

type SocialWidgetProps = { shareURL: string }

type SocialIconAttributes = {
  href: string,
  icon: React.Element<TwitterIcon | FacebookIcon | MailIcon | LinkedInIcon>,
  alt: string,
}

const SocialWidget = ({ shareURL }: SocialWidgetProps) => {
  const socialIcons: {
    [key: string]: SocialIconAttributes,
  } = {
    twitter: {
      href: `https://twitter.com/share?url=${shareURL}&hashtags=monzo`,
      icon: <TwitterIcon className={styles.icon} />,
      alt: 'Share the article on Twitter',
    },
    facebook: {
      href: `http://www.facebook.com/sharer/sharer.php?lang=en&u=${shareURL}`,
      icon: <FacebookIcon className={styles.icon} />,
      alt: 'Share the article on Facebook',
    },
    mail: {
      href: `mailto:?&subject=Check%20out%20this%20blog%20post:${shareURL}&body=${shareURL}`,
      icon: <MailIcon className={styles.icon} />,
      alt: 'Share the article via email',
    },
    linkedIn: {
      href: `https://www.linkedin.com/shareArticle?mini=true&url=${shareURL}&source=Monzo`,
      icon: <LinkedInIcon className={styles.icon} />,
      alt: 'Share the article on LinkedIn',
    },
  }

  return (
    <aside className={styles.widget}>
      <div className={styles.container}>
        {Object.keys(socialIcons).map(key => {
          const { href, icon, alt } = socialIcons[key]
          return (
            <a className={styles.icon} href={href} key={href}>
              {icon}
              <AccessibilityText>{alt}</AccessibilityText>
            </a>
          )
        })}
      </div>
    </aside>
  )
}

export default SocialWidget
